import React from 'react';
import { businessWebsiteUrl, constants } from '../../constants/configuration';
import Button from '../../components/elements/Button';
import fudrIcon from '../../assets/images/icons/fudr.svg';
import foodArtWorkImage from '../../assets/images/foodArtWork.svg';
import './DesktopLandingScreen.scss';

const desktopLandingScreenConfig = constants.desktopLandingScreen;

const DesktopLandingScreen = ({ handleRedirectToOrderingSiteClick }) => (
  <div className="desktop-landing-screen">
    <div className="desktop-landing-screen_content-section">
      <div className="business-section">
        <div className="fudr-logo">
          <img src={fudrIcon} alt="Fudr" />
        </div>
        <div className="title">{desktopLandingScreenConfig.title.lookingToKnowAboutFudr}</div>
        <div className="CTA-button">
          <Button
            content={
              <a href={businessWebsiteUrl} target="_blank" rel="noopener">
                {desktopLandingScreenConfig.CTA.visitBusinessSite}
              </a>
            }
          />
        </div>
      </div>
      <div className="separator"></div>
      <div className="ordering-section">
        <img className="fudr-art-work-logo" src={foodArtWorkImage} alt="Fudr art work" />
        <div className="title">{desktopLandingScreenConfig.title.lookingToOrderFood}</div>
        <div className="CTA-button">
          <Button
            content={desktopLandingScreenConfig.CTA.visitOrderingSite}
            onClick={handleRedirectToOrderingSiteClick}
          />
        </div>
      </div>
    </div>
  </div>
);

export default DesktopLandingScreen;
